<template>
  <!-- 模板 -->
  <Template
    name="剧情类型"
    shortName="类型"
    source="type"
  />
</template>

<script setup>
import Template from './components-plot/Template'
</script>

<style lang="less" scoped>
</style>